import { render, staticRenderFns } from "./GalleryManageServiceAdd.vue?vue&type=template&id=6dd8bb7c"
import script from "./GalleryManageServiceAdd.vue?vue&type=script&lang=js"
export * from "./GalleryManageServiceAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports